<template>
  <div>
    <b-card>
      <div>
        <h2 class="mb-2">
          {{ brandName }} Terms and Conditions
        </h2>

        <h3 class="mb-2">
Users of {{ brandName }}  service are bound by the following terms and conditions. By accessing or using the service you agree to these terms

        </h3>

        <h3 class="mb-2">
This document also constitutes the agreement for the Standard version and trials of the Premium version of the service
        </h3>

        <div>
          <ul>
            <li class="my-1">
The {{ brandName }}  service provides analysis and data on UK structured products. It service is intended for use by financial professionals and is not for private investors. Access to the service is organised by company. Each user is granted an individual login that is not to be transferred or shared
            </li>

            <li class="my-1">
Company subscriptions are divided into Standard and Premium. Standard access is granted free of charge at our discretion generally only to financial adviser firms. Premium access is a paid subscription service agreed between an authorised representative of the company and FVC. Use of the Premium service is covered by a signed agreement between the company and FVC. Details can be found <router-link :to="{name: 'privacy-policy'}">  here      </router-link>.
We reserve the right to alter or terminate the Standard service at any time
                   </li>
     <li class="my-1">
Unless expressly permitted by FVC  all content and data is for use by for the individual subscriber only. No content or data from this service should be shared externally to another person or company without prior written agreement from FVC. Users must not attempt to gain unauthorised access to any part of the service or use automated processes, scraping, data extraction or similar methods to systematically download or reproduce content or data without FVC's prior written consent
                  </li>
      <li class="my-1">
FVC does not undertake to provide any service or to cover all and every relevant product on the {{ brandName }}  service. The service is offered as is and we do not undertake to enter into any discussion about content or data
                      </li>
  <li class="my-1">
This service is not available for private investors who should seek the advice of an authorised Independent Financial Adviser or otherwise qualified professional in their jurisdiction. The {{ brandName }}  service is intended to be used by financial professionals as part of their product selection, analysis, research and compliance processes
                      </li>
  <li class="my-1">
Structured Edge is available in a premium version containing extra content and functionality. Access to the full premium version is available by company subscription under a separate signed agreement between FVC and the company
</li>
  <li class="my-1">
 Access to a trial of the premium version will be granted directly by FVC to selected parties. Trials of the premium version are for evaluation purposes only and the data accessed is not to be used for any commercial purpose, otherwise relied upon in any way, or shared with a third party. Usage limits for the Premium trial are generally lower than for a paid for account
</li>
  <li class="my-1">
Premium trials are set for a limited period, on expiry of the trial all Premium features and any saved data will be inaccessible until a company subscription is taken. FVC reserves the right to extend or withdraw any trial offered at any time
</li>

  <li class="my-1">
This service is for informational and analytical purposes only. It does not constitute, and should not be construed as: investment advice or a personal recommendation; an offer, solicitation or recommendation to buy, sell, subscribe for, or otherwise deal in any security, structured product or financial instrument; or a substitute for a subscriber's own due diligence, professional judgement, or regulatory obligations (including, where applicable, suitability or appropriateness assessments owed to end clients)

                    </li>
    <li class="my-1">
{{ brandName }}  must not be used in any way which could damage, disrupt or interfere with the operation or security of the service

               </li>
         <li class="my-1">
We accept absolutely no responsibility for the use of this service by any user who retains all responsibility for the use, interpretation or assumptions about any material contained in this service. No liability whatsoever is accepted for any loss or expense incurred from using any part of this service and no part of the contents of this service constitutes advice nor should it be relied upon for any purpose
                    </li>
    <li class="my-1">
All intellectual property rights in {{ brandName }} , including the website, reports, analysis, methodologies, calculations, data presentation, design and other content produced by FVC, are owned by or licensed to FVC. Access to the service does not transfer any ownership rights to the user or subscribing company
                      </li>
  <li class="my-1">
We reserve the right to decline or terminate access of any user to the service without notice or reason or to otherwise change the terms of this service.
                   </li>
     <li class="my-1">
In order to ensure a user is kept up to date on the structured product market, emails regarding new products and relevant matters will be sent to all users. You can change your email preferences in the account section of the website.
FVC may send users communications as is necessary for the operation and administration of the {{ brandName }}  service
            <li class="my-1">
A user can terminate their account at any time. Personal data associated with an account will be handled in accordance with FVC's <router-link :to="{name: 'privacy-policy'}">  Privacy Policy      </router-link> and applicable data protection legislation, including any legal or regulatory requirements relating to the retention of information.
Usage of the service is also subject to our <router-link :to="{name: 'privacy-policy'}">  Privacy Policy      </router-link>
</li>

            <li class="my-1">
FVC is not authorised or regulated by the Financial Conduct Authority. Structured Edge does not constitute regulated investment advice, and subscribers who are themselves regulated firms remain solely responsible for their own regulatory compliance, including any advice given to their own clients
</li>
            <li class="my-1">
These terms, and any dispute or claim arising out of or in connection with them or Structured Edge (including non-contractual disputes or claims), are governed by and construed in accordance with the laws of England and Wales. The courts of England and Wales shall have exclusive jurisdiction
</li>

          </ul>
        </div>
      </div>
    </b-card>

  </div>
</template>
<!---
import { BButton, BCard } from 'bootstrap-vue'
--->

<script>
import {
  BCard,
} from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BCard,
  },
  computed: {
    brandName() {
      return this.brand === 'se' ? 'Structured Edge' : 'Future Value Consultants'
    },
    brand() {
      return $themeConfig.app.brand
    },
  },
}
</script>
<style>

</style>
